module.exports = __webpack_public_path__ + "static/media/30-web-or-mls-DSC06757.e898ee48.jpg";